import { ActionTree, GetterTree, MutationTree } from "vuex";
import { REPORT_NOTIFICATION_SHOW, REPORT_NOTIFICATION_CLEAR as REPORT_NOTIFICATION_CLEAR_ACTION } from "../ActionTypes";
import { REPORT_NOTIFICATION_CLEAR, REPORT_NOTIFICATION_SET_STATE } from "../MutationTypes";

export interface ReportNotificationState {
  isVisible: boolean;
  title: string;
  message: string;
}

const state: ReportNotificationState = {
  isVisible: false,
  title: "Report ready",
  message: "",
};

const actions: ActionTree<any, any> = {
  [REPORT_NOTIFICATION_SHOW]({ commit }, payload: { title?: string; message: string }) {
    commit(REPORT_NOTIFICATION_SET_STATE, payload);
  },
  [REPORT_NOTIFICATION_CLEAR_ACTION]({ commit }) {
    commit(REPORT_NOTIFICATION_CLEAR);
  },
};

const mutations: MutationTree<ReportNotificationState> = {
  [REPORT_NOTIFICATION_SET_STATE](moduleState, payload: { title?: string; message: string }) {
    moduleState.isVisible = true;
    moduleState.title = payload.title || "Report ready";
    moduleState.message = payload.message;
  },
  [REPORT_NOTIFICATION_CLEAR](moduleState) {
    moduleState.isVisible = false;
    moduleState.title = "Report ready";
    moduleState.message = "";
  },
};

const getters: GetterTree<ReportNotificationState, any> = {};

export const ReportNotificationModule = {
  state,
  actions,
  getters,
  mutations,
};
